import React, { useEffect } from 'react';

import { Button, utils } from '@ergeon/core-components';
import { XMarkIcon, PhoneIcon } from '@ergeon/icons/hero/micro';

import { DEFAULT_PHONE } from './constants';
import { MobileMenuProps } from './types';

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, ergeonUrl }) => {
  const { link, display } = utils.formatPhoneNumber(DEFAULT_PHONE);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="md:hidden z-50 fixed inset-0 bg-white">
      <div className="flex flex-col h-full">
        <div className="flex justify-end p-4">
          <Button
            aria-label="Close menu"
            flavor="regular"
            isSquare
            onClick={onClose}
            taste="boundless">
            <XMarkIcon className="size-6" />
          </Button>
        </div>
        <nav className="flex flex-col items-center gap-2 p-8">
          <Button
            asAnchor
            flavor="regular"
            href={`${ergeonUrl}/gallery`}
            isFullWidth
            taste="boundless">
            Gallery
          </Button>
          <Button
            asAnchor
            flavor="regular"
            href={`${ergeonUrl}/fences`}
            isFullWidth
            taste="boundless">
            Fences
          </Button>
          <Button
            asAnchor
            flavor="regular"
            href={`${ergeonUrl}/help`}
            isFullWidth
            taste="boundless">
            Help
          </Button>
          <Button
            asAnchor
            data-track-call="true"
            flavor="warning"
            href={link}
            isFullWidth
            taste="solid">
            <PhoneIcon className="size-4" />
            {display}
          </Button>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
